import React from 'react';
import { Table, Header, Segment, Tab, Responsive } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import ThreeColumnTableRow from '../../Admin/CreateCourse/ThreeColumnTableRow';
import { fetchFaculties, fetchStudyCycle, fetchLanguages, fetchAllAcademicYears } from '../../Lookups/util';
import DetailsBHS from './DetailsBHS';
import DetailsEng from './DetailsEng';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class StudentServiceSPImplDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            organizationalUnits: [],
            studyCycles: [],
            allLanguages: [],
            academicYears: [],
            name: '',
            ects: '',
            durationYear: '',
            durationSemester: '',
            academicYearStart: '',
            studyCycle: '',
            studyProgramOrganizationalUnits: '',
            languages: '',
            classificationOfQualification: '',
            description: '',
            details: '',
            enrollmentTerms: '',
            gradingScale: '',
            nextCycleEnrollmentPossibility: '',
            professionalStatus: '',
            studyGoals: '',
            studyOutcomes: '',
            additionalInformation: '',
            studyRules: '',
            additionalInformationSource: '',

            edit: false
        };
        this.onChange = this.onChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.edit = this.edit.bind(this);
    }

    componentDidMount() {
        axios.all([fetchFaculties(), fetchStudyCycle(), fetchLanguages(), fetchAllAcademicYears()])
            .then(axios.spread((orgUnitsRes, studyCycleRes, languageRes, academicYearsRes) => {
                const organizationalUnits = orgUnitsRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.name
                }));
                const studyCycles = studyCycleRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.displayName
                }));
                const allLanguages = languageRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.name
                }));
                const academicYears = academicYearsRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.name
                }));
                this.setState({
                    organizationalUnits, studyCycles, allLanguages, academicYears
                });
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch organizationalUnits, studyCycles, languages or academicYears');
            });
    }


    onChange(keyName, value) {
        this.setState({ [keyName]: value });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    getOrgUnitName(id) {
        const { organizationalUnits } = this.state;
        const selected = organizationalUnits.find(el => el.key === id);
        if (selected && selected.text) return selected.text;
        return '';
    }

    getStudyCycleName(id) {
        const { studyCycles } = this.state;
        const selected = studyCycles.find(el => el.key === id);
        if (selected && selected.text) return selected.text;
        return '';
    }

    getAcademicYearName(id) {
        const { academicYears } = this.state;
        const selected = academicYears.find(el => el.key === id);
        if (selected && selected.text) return selected.text;
        return '';
    }

    getLanguageName(id) {
        const { allLanguages } = this.state;
        const selected = allLanguages.find(el => el.key === id);
        if (selected && selected.text) return selected.text;
        return '';
    }

    edit() {
        const {
            name, ects, durationYear, durationSemester, academicYearStart, studyCycle, studyProgramOrganizationalUnits,
            languages, classificationOfQualification, description, details, enrollmentTerms, gradingScale,
            nextCycleEnrollmentPossibility, professionalStatus, studyGoals, studyOutcomes, additionalInformation,
            studyRules, additionalInformationSource
        } = this.state;


        if (name || ects || durationYear || durationSemester || academicYearStart || studyCycle || studyProgramOrganizationalUnits ||
        languages || classificationOfQualification || description || details || enrollmentTerms || gradingScale ||
        nextCycleEnrollmentPossibility || professionalStatus || studyGoals || studyOutcomes || additionalInformation ||
        studyRules || additionalInformationSource) {
            this.setState({ edit: false });

            let editObj = { id: this.props.location.state.implementation.id, optlock: this.props.location.state.implementation.optlock };
            if (name) editObj = { ...editObj, name };
            if (ects) editObj = { ...editObj, ects };
            if (durationYear) editObj = { ...editObj, durationYear };
            if (durationSemester) editObj = { ...editObj, durationSemester };
            if (academicYearStart) editObj = { ...editObj, academicYearStart };
            // if (studyCycle) editObj = { ...editObj, studyCycle };
            // if (studyProgramOrganizationalUnits) editObj = { ...editObj, studyProgramOrganizationalUnits };
            // if (languages) editObj = { ...editObj, languages };
            if (classificationOfQualification) editObj = { ...editObj, classificationOfQualification };
            if (description) editObj = { ...editObj, description };
            if (details) editObj = { ...editObj, details };
            if (enrollmentTerms) editObj = { ...editObj, enrollmentTerms };
            if (gradingScale) editObj = { ...editObj, gradingScale };
            if (gradingScale) editObj = { ...editObj, gradingScale };
            if (nextCycleEnrollmentPossibility) editObj = { ...editObj, nextCycleEnrollmentPossibility };
            if (professionalStatus) editObj = { ...editObj, professionalStatus };
            if (studyGoals) editObj = { ...editObj, studyGoals };
            if (studyOutcomes) editObj = { ...editObj, studyOutcomes };
            if (additionalInformation) editObj = { ...editObj, additionalInformation };
            if (studyRules) editObj = { ...editObj, studyRules };
            if (additionalInformationSource) editObj = { ...editObj, additionalInformationSource };

            axios.put('study-programs/update-study-program', { ...editObj })
                .then(res => {
                    // if(languages){
                    //     languages.map(el=>(
                    //         this.removeLanguage
                    //     ))
                    // }
                    toast('Izmjena implementacije studijskog programa je uspješno izvršena.');
                })
                .then(res => { window.history.go(-1); })
                .catch(err => {
                    toast('Došlo je do greške! Izmjena podataka nije izvršena.');
                });
        } else {
            toast('Morate unijeti nove podatke ukoliko želite izvršiti izmjenu!');
        }
    }

    render() {
        const { implementation } = this.props.location.state;

        const panes = [
            {
                menuItem: 'Bosanski / hrvatski / srpski jezik',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <DetailsBHS
                        implementation={implementation}
                    />
                </Tab.Pane>)
            },
            {
                menuItem: 'Engleski jezik',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <DetailsEng
                        implementation={implementation}
                    />
                </Tab.Pane>)
            },
        ];
        return (
            <div>
                <Header as="h1">Detalji implementacije</Header>

                <Segment.Group raised>
                    <Segment clearing>
                        <Header as="h3" >
                            {localStorage.getItem('studyProgramBasicName')} - {implementation.studyProgram.name}
                        </Header>
                    </Segment>

                    <Segment clearing>
                        <Tab menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} />
                    </Segment>
                    <ToastContainer hideProgressBar />

                </Segment.Group >
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudyPrograms/StudentServiceSPImplDetails.js